import {
  GeoApi,
  GetAvailableRegionsInCountryRequest,
  GetCitiesInCountryRequest,
  GetCitizenshipsRequest,
} from '@/api/generated/fetch-client';
import { WithSignal } from '@/types/typings';

export class CountryApi {
  constructor(private readonly geoApi: GeoApi) {}

  async findCitiesByCountryCode(params: WithSignal<GetCitiesInCountryRequest>) {
    const { signal, ...requestParams } = params;
    return await this.geoApi.getAvailableCitiesInCountry(requestParams, { signal });
  }

  async findCountries(params: WithSignal<GetCitizenshipsRequest>) {
    const { signal, ...requestParams } = params;
    return await this.geoApi.getCitizenships(requestParams, { signal });
  }

  async findRegionsByCountryCode(
    params: WithSignal<GetAvailableRegionsInCountryRequest>,
  ) {
    const { signal, ...requestParams } = params;
    return await this.geoApi.getAvailableRegionsInCountry(requestParams, { signal });
  }
}
